import alt from 'components/Dispatcher';
import FeatureSource from 'sources/FeatureSource';
import FeatureActions from 'actions/FeatureActions';

export class FeatureStore{
  constructor() {
    this.state = {
      featureId: null,
      features: [],
      feature: {},
      count: 0,
      loading: false,
      params: {},
      articleParams: {}
    };

    this.registerAsync(FeatureSource);
    this.bindListeners({
      handleFetchFeatures: FeatureActions.FETCH_FEATURES,
      handleUpdateFeatures: FeatureActions.UPDATE_FEATURES,
      handleFetchFeature: FeatureActions.FETCH_FEATURE,
      handleUpdateFeature: FeatureActions.UPDATE_FEATURE,
      handleFetchLoading: FeatureActions.FETCH_LOADING,
      handleFetchSuccess: FeatureActions.FETCH_SUCCESS,
      handleFetchError: FeatureActions.FETCH_ERROR,
      handleEditFeature: FeatureActions.EDIT_FEATURE,
      handleRefreshFeature: FeatureActions.REFRESH_FEATURE,
      handleDeleteFeature: FeatureActions.DELETE_FEATURE
    });
  }
  handleFetchFeatures(params) {
    this.setState({params});
    this.getInstance().getRemoteFeatures();
  }
  handleUpdateFeatures(data) {
    this.setState(data);
  }
  handleFetchFeature(id) {
    this.setState({featureId: id});
    this.getInstance().getRemoteFeature();
  }
  handleRefreshFeature() {
    this.getInstance().getRemoteFeatures();
    this.getInstance().getRemoteFeature();
  }
  handleUpdateFeature(feature) {
    this.setState({feature});
  }
  handleFetchLoading() {
    this.setState({loading: true});
  }
  handleFetchSuccess() {
    this.setState({loading: false});
  }
  handleFetchError(error) {
    this.setState({error});
  }
  handleEditFeature(params) {
    this.setState({params});
    this.getInstance().postEditFeature();
  }
  handleDeleteFeature(id) {
    this.setState({featureId: id});
    this.getInstance().deleteRemoteFeature();
  }
}

export default alt.createStore(FeatureStore, 'FeatureStore');



// WEBPACK FOOTER //
// ./src/stores/FeatureStore.js